import React, { Component } from 'react'
import dateUtil from '../utils/date.util'
import RadioGroup, { RadioGroupItem } from './RadioGroup'
import DatePicker from './DatePicker/DatePicker'
import Row from './Row/Row'
import { i18n } from "../i18n/i18n";

type CustomDatePickerDateName = 'custom' | 'currentWeek' | 'currentMonth'
type CustomDatePickerDates = RadioGroupItem[]

interface Props {
  from: string
  to: string
  time?: boolean
  onChange: (name: string, date: string) => void
}

interface State {
  date: CustomDatePickerDateName
}

export default class CustomDatePicker
  extends Component<Props, State> {
  initialState: State = {
    date: 'currentWeek'
  }

  dates: CustomDatePickerDates = [
    { name: 'custom', label: i18n('Custom') },
    { name: 'currentWeek', label: i18n('Current week') },
    { name: 'currentMonth', label: i18n('Current month') }
  ]

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleDatePickerChange = this.handleDatePickerChange.bind(this)
  }

  handleDateChange (date: CustomDatePickerDateName) {
    this.setState({ date })
    if (date === 'currentWeek') {
      const from = dateUtil.startOfWeek()
      const to = dateUtil.nowUtc()
      this.props.onChange('from', from)
      this.props.onChange('to', to)
    } else if (date === 'currentMonth') {
      const from = dateUtil.startOfMonth()
      const to = dateUtil.nowUtc()
      this.props.onChange('from', from)
      this.props.onChange('to', to)
    }
  }

  handleDatePickerChange (name: string, date: string) {
    if (name === 'from') this.props.onChange('from', date)
    if (name === 'to') this.props.onChange('to', date)
    this.setState({ date: 'custom' })
  }

  componentDidMount () {
    this.handleDateChange(this.state.date)
  }

  render () {
    return (
      <div className="block">
        <RadioGroup
          label={i18n("Choose date")}
          radios={this.dates}
          checked={this.state.date}
          onChange={this.handleDateChange} />
        <Row column={2}>
          <DatePicker
            name="from"
            value={this.props.from}
            label={i18n("From")}
            time={this.props.time}
            onChange={this.handleDatePickerChange} />
          <DatePicker
            name="to"
            value={this.props.to}
            label={i18n("To")}
            time={this.props.time}
            onChange={this.handleDatePickerChange} />
        </Row>
      </div>
    )
  }
}
